module.exports = __webpack_public_path__ + "img/clinica.4d6d2e57.svg";